module.exports = __webpack_public_path__ + "static/media/pdf.3523e067.png";